/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useEffect, useRef } from 'preact/hooks';
import { ItemInfo } from './Legend.type';

/**
 * Hook to track focus item ref and ensure focus item is always
 * in view.
 */
export function useItemFocus(focusedItem: ItemInfo) {
  const focusedItemRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (focusedItem.isFocusVisible) {
      focusedItemRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [focusedItem]);

  return { focusedItemRef };
}
